var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletHandsSheetGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.85 14.8499H38.5999V89.4399H133.85V14.8499Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8999 100.02L2.67993 109.62V74.8L15.8999 100.02Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.64 142.34L132.47 146.87L98.7 146.55L100.17 136.64L133.64 142.34Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6299 60.0499L19.3499 52.7799C19.3499 52.7799 29.0599 47.4999 31.1699 50.8599C33.2799 54.2199 25.6299 60.0499 25.6299 60.0499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.11 109.48L111.79 88.32C111.79 88.32 113.05 79.05 116.56 79.05C120.07 79.05 119 88.51 119 88.51L117.65 107.84",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.11 109.48L111.79 88.32C111.79 88.32 113.05 79.05 116.56 79.05C120.07 79.05 119 88.51 119 88.51L117.65 107.84",
    stroke: "white",
    strokeWidth: 0.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.86 64.0001C116.95 64.8201 117.73 65.3701 118.86 65.3701C119.99 65.3701 120.64 64.8201 120.64 64.0701C120.64 63.3201 120.19 63.0701 119.17 62.7701L118.17 62.5201C116.77 62.1601 116.17 61.5201 116.17 60.5201C116.17 59.2501 117.28 58.3601 118.86 58.3601C119.178 58.3242 119.501 58.3524 119.808 58.4432C120.116 58.534 120.402 58.6855 120.65 58.8887C120.898 59.0919 121.103 59.3427 121.252 59.6264C121.401 59.91 121.493 60.2207 121.52 60.5401H120.52C120.463 60.1349 120.248 59.7688 119.922 59.5216C119.596 59.2743 119.185 59.1659 118.78 59.2201C117.78 59.2201 117.11 59.7301 117.11 60.4701C117.11 61.0501 117.53 61.3901 118.57 61.6601L119.36 61.8701C120.94 62.2701 121.58 62.8701 121.58 63.9701C121.58 65.3601 120.48 66.2301 118.73 66.2301C116.98 66.2301 116 65.3101 115.91 64.0001H116.86Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.02 71.1601C124.018 71.1601 128.07 67.1082 128.07 62.1101C128.07 57.1119 124.018 53.0601 119.02 53.0601C114.022 53.0601 109.97 57.1119 109.97 62.1101C109.97 67.1082 114.022 71.1601 119.02 71.1601Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.21 52.6199C60.2817 52.6199 59.3915 52.2511 58.7351 51.5947C58.0787 50.9384 57.71 50.0481 57.71 49.1199C57.71 48.1916 58.0787 47.3014 58.7351 46.645C59.3915 45.9886 60.2817 45.6199 61.21 45.6199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.21 43.5701C60.2817 43.5701 59.3915 43.2013 58.7351 42.5449C58.0787 41.8886 57.71 40.9983 57.71 40.0701C57.71 39.1418 58.0787 38.2516 58.7351 37.5952C59.3915 36.9388 60.2817 36.5701 61.21 36.5701",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36.6099C87.9283 36.6099 88.8185 36.9786 89.4749 37.635C90.1313 38.2914 90.5 39.1816 90.5 40.1099C90.5 41.0381 90.1313 41.9284 89.4749 42.5847C88.8185 43.2411 87.9283 43.6099 87 43.6099",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45.6599C87.9283 45.6599 88.8185 46.0287 89.4749 46.685C90.1313 47.3414 90.5 48.2317 90.5 49.1599C90.5 50.0882 90.1313 50.9784 89.4749 51.6348C88.8185 52.2912 87.9283 52.6599 87 52.6599",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.21 36.6099C61.21 35.6816 61.5787 34.7914 62.2351 34.135C62.8915 33.4786 63.7817 33.1099 64.71 33.1099C65.6382 33.1099 66.5285 33.4786 67.1848 34.135C67.8412 34.7914 68.21 35.6816 68.21 36.6099",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.26 36.6099C70.26 35.6816 70.6288 34.7914 71.2851 34.135C71.9415 33.4786 72.8318 33.1099 73.76 33.1099C74.6883 33.1099 75.5785 33.4786 76.2349 34.135C76.8913 34.7914 77.26 35.6816 77.26 36.6099",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3101 36.6099C79.3101 35.6816 79.6788 34.7914 80.3352 34.135C80.9916 33.4786 81.8818 33.1099 82.8101 33.1099C83.7383 33.1099 84.6286 33.4786 85.2849 34.135C85.9413 34.7914 86.3101 35.6816 86.3101 36.6099",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.26 52.6199C86.26 53.0795 86.1695 53.5346 85.9936 53.9593C85.8177 54.3839 85.5599 54.7697 85.2349 55.0947C84.9099 55.4198 84.524 55.6776 84.0994 55.8535C83.6748 56.0293 83.2196 56.1199 82.76 56.1199C82.3004 56.1199 81.8453 56.0293 81.4206 55.8535C80.996 55.6776 80.6101 55.4198 80.2851 55.0947C79.9601 54.7697 79.7023 54.3839 79.5264 53.9593C79.3505 53.5346 79.26 53.0795 79.26 52.6199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.22 52.6199C77.22 53.5481 76.8512 54.4384 76.1948 55.0947C75.5385 55.7511 74.6482 56.1199 73.72 56.1199C72.7917 56.1199 71.9015 55.7511 71.2451 55.0947C70.5887 54.4384 70.22 53.5481 70.22 52.6199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1699 52.6199C68.1699 53.5481 67.8012 54.4384 67.1448 55.0947C66.4884 55.7511 65.5982 56.1199 64.6699 56.1199C63.7417 56.1199 62.8514 55.7511 62.195 55.0947C61.5387 54.4384 61.1699 53.5481 61.1699 52.6199",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 50.24V12.43C26.3999 10.6521 27.1055 8.9469 28.3617 7.68882C29.6179 6.43073 31.322 5.72262 33.0999 5.71997H140.68C142.458 5.72262 144.162 6.43073 145.418 7.68882C146.674 8.9469 147.38 10.6521 147.38 12.43V91.69C147.38 93.4678 146.674 95.173 145.418 96.4311C144.162 97.6892 142.458 98.3973 140.68 98.4H127.08",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.91 98.3999H33.0999C31.322 98.3972 29.6179 97.6891 28.3617 96.431C27.1055 95.173 26.3999 93.4678 26.3999 91.6899V68.1299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 55.92C142.319 55.92 143.47 54.7694 143.47 53.35C143.47 51.9307 142.319 50.78 140.9 50.78C139.481 50.78 138.33 51.9307 138.33 53.35C138.33 54.7694 139.481 55.92 140.9 55.92Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32007 62.3999L17.3901 54.7399C17.3901 54.7399 29.1001 47.6899 31.1701 50.8599C33.2401 54.0299 26.2701 59.4099 26.2701 59.4099L16.2701 66.6899L14.8701 78.2799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8401 95.75L25.4201 89.71",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.11 41.5801L0.719971 64.1101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M108.94 80.9099H49.3799V24.8699H65.8899",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.45 24.8699H124.68V80.9099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.83 57.5699V23.8799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.96 50.3201H101.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3499 50.3201H66.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M102.83 81.9099V72.1399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.54 89.6199L117.65 107.84C117.65 107.84 123.35 106.36 124.97 110.67C129.97 109.12 132.33 113.95 132.33 113.95C137.46 113.12 138.33 117.61 137.33 120.19C136.33 122.77 129.08 142 129.08 142",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.08 137.79L100.79 118.79C100.38 115.02 108.11 109.49 108.11 109.49L111.23 90.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletHandsSheetGrey);
export default __webpack_public_path__ + "static/media/tablet_hands_sheet_grey.a007e0084d454e11e7c2d2aa0001eff2.svg";
export { ForwardRef as ReactComponent };